/* Display-only offer education and catalogue browsing. Native Shopify owns purchasing. */
(() => {
  function offerSummary(value) {
    const paid = [2, 4, 6].includes(Number(value)) ? Number(value) : 2;
    return { paid, free: paid, total: paid * 2 };
  }
  function visibleProducts(items, category, limit) {
    return items.filter(item => category === 'all' || item.category === category)
      .sort((a, b) => a.rank - b.rank).slice(0, limit);
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { offerSummary, visibleProducts };
  if (typeof customElements === 'undefined') return;

  class OfferSelector extends HTMLElement {
    connectedCallback() {
      this.onClick ||= event => {
        const button = event.target.closest('button[data-paid]');
        if (button && this.contains(button)) this.update(button.dataset.paid);
      };
      this.addEventListener('click', this.onClick);
      this.querySelectorAll('button[data-paid]').forEach(button => { button.disabled = false; });
      this.update(2);
    }
    disconnectedCallback() { this.removeEventListener('click', this.onClick); }
    update(value) {
      const summary = offerSummary(value);
      this.querySelectorAll('button[data-paid]').forEach(button => {
        button.setAttribute('aria-pressed', String(Number(button.dataset.paid) === summary.paid));
      });
      Object.entries(summary).forEach(([key, count]) => {
        this.querySelectorAll(`[data-offer-${key}]`).forEach(node => { node.textContent = count; });
      });
    }
  }
  class ProductEdit extends HTMLElement {
    connectedCallback() {
      this.category = 'all';
      this.limit = Number(this.dataset.initialCount) || 8;
      this.cards = [...this.querySelectorAll('[data-product-card]')].map(node => ({
        node, category: node.dataset.category, rank: Number(node.dataset.rank), id: node.dataset.productCard
      }));
      this.onClick ||= event => {
        const filter = event.target.closest('button[data-category]');
        if (filter && this.contains(filter)) {
          this.category = filter.dataset.category;
          this.limit = Number(this.dataset.initialCount) || 8;
          this.update();
        }
        if (event.target.closest('[data-show-more]')) {
          const firstNewCard = visibleProducts(this.cards, this.category, Infinity).find(card => card.node.hidden);
          this.limit = Infinity;
          this.update();
          firstNewCard?.node.querySelector('a')?.focus();
        }
      };
      this.addEventListener('click', this.onClick);
      this.querySelector('[data-product-filters]').hidden = false;
      this.update();
    }
    disconnectedCallback() { this.removeEventListener('click', this.onClick); }
    update() {
      const visible = visibleProducts(this.cards, this.category, this.limit);
      const selected = new Set(visible);
      this.cards.forEach(card => { card.node.hidden = !selected.has(card); });
      // Keep keyboard and reading order identical to the visual order.
      const grid = this.querySelector('[data-product-grid]');
      visible.forEach(card => grid.append(card.node));
      this.querySelectorAll('button[data-category]').forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.category === this.category));
      });
      const total = visibleProducts(this.cards, this.category, Infinity).length;
      this.querySelector('[data-product-count]').textContent = `${visible.length} pieces to discover`;
      this.querySelector('[data-show-more]').hidden = visible.length >= total;
    }
  }
  if (!customElements.get('sf-offer-selector')) customElements.define('sf-offer-selector', OfferSelector);
  if (!customElements.get('sf-product-edit')) customElements.define('sf-product-edit', ProductEdit);
})();
